export default class BaseEnv {
  scene: any;
  camera: any;
  renderer: any;
  controller: any;
  active: boolean;

  constructor(scene: any, camera: any, renderer: any, controller: any = null) {
    this.scene = scene;
    this.camera = camera;
    this.renderer = renderer;
    this.controller = controller;
    this.active = false;
  }

  activate() {
    this.active = true;
    this.scene.activate();
    this.controller?.activate();
  }

  deactivate() {
    this.active = false;
    this.scene.deactivate();
    this.controller?.deactivate();
  }

  update(deltaTime: number) {
    if (this.active && this.scene.update) {
      this.scene.update(deltaTime);
    }
    if (this.controller && this.controller.update) {
      this.controller.update(deltaTime);
    }
  }

  dispose() {
    if (this.scene.disposeScene) {
      this.scene.disposeScene();
    }
  }
}

